<template>
	<div class="tourManage mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">巡检记录</div>
		</div>
		<div class="mainBot ">
			<div class="itemTitleBox disStart">
				<span class="title">故障派单</span>
			</div>
			<div class="BtnBox disBetween">
				<div class="searchBox disBetween">
					<div class="disBetween searchLeft">
						<div class="myinputBox">
							<el-input clearable v-model="searchObj.communityName" placeholder="请输入社区名称"></el-input>
							<!-- <el-select clearable v-model="searchObj.communityName" allow-create filterable remote
								reserve-keyword placeholder="请输入社区关键词" :remote-method="remoteMethod"
								@change="changeSelect">
								<el-option v-for="item in restaurants" :key="item.communityId"
									:label="item.communityName" :value="item.communityName">
								</el-option>
							</el-select> -->
						</div>
						<div class="myinputBox">
							<el-select clearable v-model="searchObj.repairUserId" slot="prepend"
								placeholder="请输入巡检人员名称">
								<el-option v-for="(item,inx) in personList" :key="inx" :label="item.repairUserName"
									:value="item.repairUserId"></el-option>
							</el-select>
						</div>
						<div class="myinputBox">
							<el-cascader clearable ref="cascader1" placeholder="请选择地区"
								:props="{ value: 'areaCode',label: 'areaName',children: 'childList'}"
								v-model="areaValue" :options="areaList" @change="handleChange($event,1)">
							</el-cascader>
						</div>
						<div class="myinputBox myinputBox5">
							<el-date-picker  v-model="searchObj.startTime" value-format="yyyy-MM-dd" type="date"
								placeholder="开始时间">
							</el-date-picker>
						</div>
						<div class="myinputBox myinputBox5">
							<el-date-picker v-model="searchObj.endTime" value-format="yyyy-MM-dd" type="date"
								placeholder="结束时间">
							</el-date-picker>	
							<!-- <el-date-picker v-model="searchObj.searchData" type="daterange" range-separator="~"
								value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker> -->
						</div>
						<el-button type="success" @click="toSearch">查询</el-button>
					</div>
					<el-button type="success" @click="exportData">导出</el-button>
				</div>

			</div>
			<div class="listBox">
				<div style="height: 100%;width: 100%;" v-loading="loading">
					<div class="content myTable">
						<el-table :data="tableData" stripe style="width: 100%">
							<el-table-column type="index" label="序号">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="patrolTime" label="巡检日期">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="repairUserName" label="巡检人员">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="repairUserPhone" label="联系方式">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="communityName" label="社区名称">
							</el-table-column>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="patrolResultType" label="处理结果">
								<template slot-scope="scope">
									<span>{{scope.row.patrolResultType==1?'正常':scope.row.patrolResultType==2?'异常':''}}</span>
								</template>
							</el-table-column>
							</el-table-column>
							<el-table-column prop="patrolLog" label="巡检说明" width="300"></el-table-column>
						</el-table>
					</div>
					<div class="pagination  mypagination">
						<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
							:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
							layout="total, prev, pager, next,jumper" ref="pagination"
							@current-change="handleCurrentChange">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import {
		timestampToDate
	} from "../../../../assets/js/common.js"
	export default {
		name: "tourManage",
		components: {},
		data() {
			return {
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				tableData: [],
				personList: [],
				loading: false,
				searchObj: {
					pageNo: 1, //当前页
					pageSize: 10, //当前页个数
					communityName: "", //社区名称
					repairUserId: "", //巡检人员
					provinceCode: "", //省
					cityCode: "", //市
					areaCode: "", //区
					startTime: null, //开始时间
					endTime: null, //结束时间
					searchData: [],
				},
				restaurants: [],
				options: [],
				areaList: [],
				areaValue: "",
			}
		},
		mounted() {
			// let time = new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000
			// this.searchObj.searchData = [timestampToDate(time), timestampToDate(new Date().getTime())]
			
			this.$nextTick(() => {
				this.getData()
				this.getpersonList()
				if (!(localStorage.getItem("areaList"))) {
					this.getAreaList()
				} else {
					this.$set(this, "areaList", JSON.parse(localStorage.getItem("areaList")))
				}
			})
		},
		methods: {
			exportData(){
				let obj={
					communityName:this.searchObj.communityName,
					repairUserId:this.searchObj.repairUserId,
					provinceCode:this.searchObj.provinceCode,
					cityCode:this.searchObj.cityCode,
					areaCode:this.searchObj.areaCode,
					startTime: this.searchObj.startTime, //开始时间
					endTime: this.searchObj.endTime, //结束时间
					
				}
				this.$api.exportOrderPatrol(obj,"巡检记录").then((res)=>{
					if(res.returnCode==200){
						
					}
				})
			},
			getpersonList() {
				this.$api.listAllOrderRepairUser().then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "personList", res.obj)
					}
				})
			},
			// 省市区数据
			getAreaList() {
				this.$api.listAllAreaInfo().then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "areaList", res.obj)
						localStorage.setItem('areaList', JSON.stringify(res.obj))
					}
				})
			},
			remoteMethod(query) {
				let that = this
				if (query !== '') {
					let searchObj = {
						search: query,
						pageNo: 1, //当前页
						pageSize: 1000, //当
						provinceCode: "", //省级编号
						cityCode: "", //市级编号
						areaCode: "" //区级编号
					}
					that.$api.listCommunityInfo(searchObj).then((res) => {
						if (res.returnCode == 200) {
							that.$set(that, "restaurants", res.obj.list)
							setTimeout(() => {
								that.options = that.restaurants.filter(item => {
									return item.communityName.toLowerCase()
										.indexOf(query.toLowerCase()) > -1;
								});
							}, 200);

						}
					})

				} else {
					this.options = [];
				}
			},
			changeSelect(n) {
				this.$set(this.searchObj, "communitySiteId", "")
				this.$set(this.searchObj, "communityName", "")
				let item = this.options.find((item, inx) => {
					return item.communityId == n
				})
				if (item) {
					this.$set(this.searchObj, "communityName", item.communityName)
				} else {
					this.$set(this.searchObj, "communityName", n)
				}
				
			},
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.value
				})
				return obj.text
			},
			toSearch() {
				this.$set(this.PageInfo,"pagenum",1)
				this.$set(this.searchObj,"pageNo",1)
				this.$nextTick(() => {
					this.getData()
				})
			},
			getData(n) {
				this.loading = true
				this.$api.listOrderPatrol(this.searchObj).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "tableData", res.obj.list)
						this.$set(this.PageInfo, "total", res.obj.total || 0)
						this.loading = false
					}
				})
			},
			// 选择分页
			handleCurrentChange(val) {
				this.$set(this.PageInfo,"pagenum",val)
				this.$set(this.searchObj,"pageNo",val)
				this.getData({})
			},
			handleChange(value, n) {
				let nodesInfo = this.$refs['cascader' + n].getCheckedNodes()
				if (nodesInfo.length > 0) {
					this.$set(this.searchObj, "provinceCode", nodesInfo[0].path[0] || "")
					this.$set(this.searchObj, "cityCode", nodesInfo[0].path[1] || "")
					this.$set(this.searchObj, "areaCode", nodesInfo[0].path[2] || "")
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./tourManage.scss";
</style>